/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

import Modal from "../components/Modal";

import { useAuthStore, useLoadingStore, useModalStore } from "../stores/hooks";

import { VEHICLE_TYPE_LABELS } from "../constants";

function UpdateVehicleInfoModal({
  initVehicleInfo,
  onUpdate,
}) {
  const { ...actions } = useAuthStore();
  const { ...loadingActions } = useLoadingStore();
  const { closeModal } = useModalStore();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    if (initVehicleInfo) {
      reset({
        vehicleType: initVehicleInfo.vehicleType,
        vehicleNumber: initVehicleInfo.vehicleNumber,
        modelName: initVehicleInfo.modelName,
      });
    }
  }, [initVehicleInfo]);

  const handleCancel = () => {
    onUpdate();
    closeModal();
  };

  const onSubmit = async ({
    vehicleType,
    vehicleNumber,
    modelName,
  }) => {
    try {
      const data = {
        vehicleType,
        vehicleNumber,
        modelName,
      };

      loadingActions.startLoading();

      if (initVehicleInfo) {
        await actions.updateVehicleInfo(initVehicleInfo.id, data);
      } else {
        await actions.createVehicleInfo(data);
      }

      reset();
      closeModal();
      onUpdate();
    } catch (e) {
      window.alert(`배송 차량 정보 제공에 실패했습니다. ${e?.message}`);
    } finally {
      loadingActions.finishLoading();
    }
  };

  return (
    <Modal>
      <div className="p-10">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-10">
            <div className="font-bold text-16 mb-10">차량 종류(필수)</div>
            <div className="flex gap-10 items-center justify-between flex-row">
              <select
                type="select" 
                className="p-10 bg-[#f6f6f6] min-w-0 flex-1"
                {...register("vehicleType", {
                  required: "차량 종류를 선택해주세요.",
                })}
              >
                <option value="">차량 종류를 선택해주세요.</option>
                {Object.entries(VEHICLE_TYPE_LABELS).map(([key, value]) => (
                  <option key={key} value={key}>
                    {value}
                  </option>
                ))}
              </select>
            </div>
            <div className="text-orange text-14 mt-2">
              {errors.vehicleType
                ? errors.vehicleType.message
                : ""}
            </div>
          </div>
          <div className="mb-10">
            <div className="font-bold text-16 mb-10">차량 번호(필수)</div>
            <div className="flex gap-10 items-center justify-between flex-row">
              <input
                type="text"
                className="p-10 bg-[#f6f6f6] min-w-0 flex-1"
                {...register("vehicleNumber", {
                  required: "차량 번호를 입력해주세요.",
                  pattern: {
                    value: /^[0-9A-Za-z가-힣]+$/,
                    message: "차량 번호를 정확히 입력해주세요.",
                  },
                })}                
              />
            </div>
            <div className="text-orange text-14 mt-2">
              {errors.vehicleNumber ? errors.vehicleNumber.message : ""}
            </div>
          </div>
          <div className="mb-10">
            <div className="font-bold text-16 mb-10">차량 모델명(필수)</div>
            <input
              type="text"
              className="p-10 bg-[#f6f6f6] w-full"
              {...register("modelName", {
                required: "차량 모델명을 입력해주세요.",
                pattern: {
                  value: /^[0-9A-Za-z가-힣]+$/,
                  message: "차량 모델명을 정확히 입력해주세요.",
                },
              })}
            />
            <div className="text-orange text-14 mt-2">
              {errors.modelName ? errors.modelName.message : ""}
            </div>
          </div>
          <div className="grid gap-10 mt-10">
            <button type="submit" className="bg-orange text-white w-full p-10">
              수정하기
            </button>
            <button type="button" className="w-full p-10" onClick={handleCancel}>
              취소
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default UpdateVehicleInfoModal;
